// extracted by mini-css-extract-plugin
export default {"Box":"repo-picker-module__Box--wkZQu","Text":"repo-picker-module__Text--JPDIB","Text_1":"repo-picker-module__Text_1--ZBava"};